import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[set-parent-image-size]',
    standalone: false
})
export class ParentImageSizeDirective {
    constructor(element: ElementRef) {
        const img = element.nativeElement as HTMLImageElement;
        img.onload = () =>
            img.parentElement.dataset['size'] = `${img.naturalWidth}x${img.naturalHeight}`;
    }
}
